<template>
  <v-btn :to="innerTo" :target="target" :flat="flat" :depressed="depressed" :large="large" :block="block" :dark="dark" :color="color" v-if="innerTo != null">
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  data () {
    return {
      innerTo: null,
      innerClass: ""
    };
  },
  props: {
    to: [ String, Object ],
    target: {
      type: String,
      default: "_self"
    },
    flat: Boolean,
    depressed: Boolean,
    large: Boolean,
    block: Boolean,
    dark: Boolean,
    color: String,
  },
  watch: {
    to (v) {
      if (v != null) {
        if (typeof v == "string") {
          if (window.testovaci_klient && !v.startsWith("/testovaci-klient")) {
            v = "/testovaci-klient" + v;
          }
        }
        else {
          if (window.testovaci_klient && !v.path.startsWith("/testovaci-klient")) {
            v.path = "/testovaci-klient" + v.path;
          }
        }
      }
      this.innerTo = v;
    }
  },
  mounted () {
    this.innerTo = this.to;
    if (typeof this.innerTo != "undefined" && this.innerTo != null) {
      if (typeof this.innerTo == "string") {
        if (window.testovaci_klient && !this.innerTo.startsWith("/testovaci-klient")) {
          this.innerTo = "/testovaci-klient" + this.innerTo;
        }
      }
      else {
        if (window.testovaci_klient && !this.innerTo.path.startsWith("/testovaci-klient")) {
          this.innerTo.path = "/testovaci-klient" + this.innerTo.path;
        }
      }
    }
    this.innerClass = this.class;
  }
}
</script>
